export { default as MiniContentCarousel } from './mini-content-carousel';
